var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.25,
    height: 22,
    viewBox: "0 0 19.25 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-plus-svgrepo-com",
    d: "M14.438,12.547v1.031a.517.517,0,0,1-.516.516H10.656v3.266a.517.517,0,0,1-.516.516H9.109a.517.517,0,0,1-.516-.516V14.094H5.328a.517.517,0,0,1-.516-.516V12.547a.517.517,0,0,1,.516-.516H8.594V8.766a.517.517,0,0,1,.516-.516h1.031a.517.517,0,0,1,.516.516v3.266h3.266A.517.517,0,0,1,14.438,12.547ZM19.25,4.813V19.938A2.063,2.063,0,0,1,17.188,22H2.063A2.063,2.063,0,0,1,0,19.938V4.813A2.063,2.063,0,0,1,2.063,2.75H4.125V.516A.517.517,0,0,1,4.641,0H6.359a.517.517,0,0,1,.516.516V2.75h5.5V.516A.517.517,0,0,1,12.891,0h1.719a.517.517,0,0,1,.516.516V2.75h2.063A2.063,2.063,0,0,1,19.25,4.813ZM17.188,19.68V6.875H2.063v12.8a.259.259,0,0,0,.258.258H16.93A.259.259,0,0,0,17.188,19.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassBookings);
export default __webpack_public_path__ + "static/media/ClassBookings.56e1ef2a45678bb0ce8069ee80a6da89.svg";
export { ForwardRef as ReactComponent };